import React, { useState, useEffect, useRef } from "react";
import { useHistory, useLocation } from "react-router-dom";
import InnerHeader from "../etc/innerheader";
import styles from "./mobilemycoaching.module.css";
import { postFetch } from "../../fetch/fetch";
import { IonLoading } from "@ionic/react";

const MobileCoachDetail: React.FC<any> = (props) => {

    const location = useLocation<any>();
    const history = useHistory();
    const headerRef = useRef<any>(null);
    const [coach, setCoach] = useState<any>(null);
    const [bodyHeight, setBodyHeight] = useState(100);

    const [availableTimeMenu, setAvailableTimeMenu] = useState<string>("online");
    const [isIncludeOnline, setIsIncludeOnline] = useState<boolean>(false);
    const [isIncludeOffline, setIsIncludeOffline] = useState<boolean>(false);

    const [disabled, setDisabled] = useState<boolean>(true);
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {

        if (!coach) {
            return;
        }

        if (!coach.isAvailable) {
            setDisabled(true);
            return;
        }

        if (!coach.isAvailable.value) {
            setDisabled(true);
            return;
        }

        if (coach.isAvailable.value) {
            setDisabled(false);
            return;
        }


    }, [coach]);

    useEffect(() => {

        if (!location || !location.state) {
            return;
        }

        console.log(location.state);

        if (location.state.teacher) {
            const classModes = location.state.teacher.classModes?.value || [];
            var isIncludeOnline = classModes.includes("온라인") || classModes.includes("온/오프라인");
            var isIncludeOffline = classModes.includes("오프라인") || classModes.includes("온/오프라인");

            setIsIncludeOnline(isIncludeOnline);
            setIsIncludeOffline(isIncludeOffline);


            if (!isIncludeOnline) {
                setAvailableTimeMenu("offline");
            }
        }

        setCoach(location.state.teacher);

    }, []);

    useEffect(() => {

        caculateBodyHeight();

        window.addEventListener("resize", caculateBodyHeight);

        return () => window.removeEventListener("resize", caculateBodyHeight);

    }, [headerRef]);

    const caculateBodyHeight = () => {
        setTimeout(() => {

            if (!headerRef || !headerRef.current) {
                console.log("headerRef is null2");
                return;
            }


            const value = +getComputedStyle(document.documentElement).getPropertyValue("--sat").split("p")[0];
            const totalHeight = window.innerHeight;
            const safeareaTop = value;
            console.log(headerRef.current);
            const headerHeight = headerRef.current.offsetHeight;

            const lastHeight = totalHeight - safeareaTop - headerHeight;

            setBodyHeight(lastHeight);

        }, 50);
    }

    const submit = async () => {

        try {

            if (!coach || !coach.userId) {
                console.log("Coach or userId is not defined");
                return;
            }

            if (!coach.isAvailable || coach.isAvailable.value === null) {
                alert("신청이 불가능한 코치입니다.");
                return;
            }

            setLoading(true);

            const result : any = await postFetch("/dashboard/mycoach/teacherselect/submit", {
                teacherId: coach.userId
            });

            setLoading(false);

            if(result.message === "NOPARENT"){
                alert("학부모 계정은 코치 신청이 불가능합니다.");
                return;
            }


            if(result.message === "success"){
                history.push({
                    pathname: "/mobiledashboard/mycoaching",
                    state: {
                        nextCurrentStatus: 2,
                        nextSubStatus: 2
                    }
                })
            }

            console.log(result);

        } catch (e) {
            console.log(e);
        }

    }


    return (
        <div>
            <InnerHeader headerRef={headerRef} title="" />
            {
                coach
                    ?
                    <div style={{
                        height: bodyHeight,
                        overflowY: "scroll",
                        position: "relative",
                        paddingBottom: "4.5rem"
                    }}
                        className={styles.body}
                    >
                        <div>
                            <img src={coach?.profilePicture?.value[0]?.url} alt={coach?.nickName}
                                style={{
                                    width: "100%",
                                    aspectRatio: "1/1",
                                    objectFit: "cover"
                                }}
                            />
                        </div>
                        <div
                            style={{
                                width: "90.4%",
                                margin: "0 auto",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                marginTop: "1.4rem"
                            }}
                        >
                            {
                                ["이름", "", "수업방식", "", "신청가능여부"].map((item, index) => {

                                    const classModes = coach?.classModes?.value || [];

                                    var isIncludeOnline = classModes.includes("온라인") || classModes.includes("온/오프라인");
                                    var isIncludeOffline = classModes.includes("오프라인") || classModes.includes("온/오프라인");
                                    var isIncludeBoth = classModes.includes("온/오프라인");

                                    var classModeText = "";

                                    if (isIncludeBoth) {
                                        classModeText = "온/오프라인";
                                    } else if (isIncludeOnline) {
                                        classModeText = "온라인";
                                    } else if (isIncludeOffline) {
                                        classModeText = "오프라인";
                                    } else {
                                        classModeText = "미정";
                                    }

                                    if (item) {

                                        return (
                                            <div key={index} style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                flex: 1,
                                                height: "2.8rem",
                                            }}>
                                                <div style={{
                                                    color: "#7e7e7e",
                                                    textAlign: "center",
                                                    fontSize: "0.625rem",
                                                    marginBottom: "0.1rem"
                                                }}>
                                                    {item}
                                                </div>
                                                <div style={{
                                                    textAlign: "center",
                                                    lineHeight: "1.518rem",
                                                    color: (index === 4 && coach?.isAvailable?.value === null) ? "#ff1e00" : "#000000",
                                                }}>
                                                    {
                                                        index === 0 ? coach?.nickName?.value
                                                            :
                                                            index === 2 ? classModeText
                                                                :
                                                                index === 4 ? coach?.isAvailable.value ? "신청가능" : "신청마감"
                                                                    :
                                                                    ""
                                                    }
                                                </div>
                                            </div>
                                        )

                                    } else {
                                        return (
                                            <div key={index} style={{
                                                height: "2.8rem",
                                                borderRight: "0.0625rem solid #eaeaea",
                                            }}>

                                            </div>
                                        )
                                    }


                                })
                            }
                        </div>
                        <div style={{
                            width: "90.4%",
                            margin: "0 auto",
                            marginTop: "1.06rem",
                            backgroundColor: "#f8f8f8",
                            padding: "1.18rem 0.875rem 1.187rem 0.875rem"
                        }}>
                            <div style={{
                                fontFamily: "Apple_B",
                                lineHeight: "1.5625rem",
                                marginBottom: "0.3rem"
                            }}>
                                코치의 "한 줄"
                            </div>
                            <div style={{
                                lineHeight: "1.5625rem",
                                color: "#616161",
                                fontSize: "0.9rem"
                            }}>
                                {coach?.introduceLine?.value}
                            </div>
                        </div>
                        <div style={{
                            width: "90.4%",
                            margin: "0 auto",
                            marginTop: "4rem",
                            marginBottom: "1.06rem",
                        }}>
                            <div style={{
                                fontFamily: "Apple_B",
                            }}>
                                수업 가능한 요일 및 시간
                            </div>
                            <div style={{
                                marginTop: "1.41rem",
                                lineHeight: "1.51rem",
                                display: "flex"
                            }}>
                                {
                                    isIncludeOnline ?
                                        <div style={{
                                            borderBottom: availableTimeMenu === "online" ? "0.2rem solid #4880ed" : "0.2rem solid transparent",
                                            width: "4.5rem",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                        }}
                                            onClick={() => setAvailableTimeMenu("online")}
                                        >
                                            온라인
                                        </div>
                                        :
                                        ""
                                }
                                {
                                    isIncludeOffline ?
                                        <div style={{
                                            borderBottom: availableTimeMenu === "offline" ? "0.2rem solid #4880ed" : "0.2rem solid transparent",
                                            width: "4.5rem",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                        }}
                                            onClick={() => setAvailableTimeMenu("offline")}
                                        >
                                            오프라인
                                        </div>
                                        :
                                        ""
                                }
                            </div>
                        </div>
                        <div style={{
                            width: "90.4%",
                            margin: "0 auto",
                            display: "grid",
                            gridTemplateColumns: "repeat(3, 1fr)",
                            gap: "0.31rem"
                        }}>
                            {
                                new Array(6).fill(0).map((_: any, index: number) => {
                                    const dayOfWeek = ["월", "화", "수", "목", "금", "토"];
                                    const dayOfWeekText = dayOfWeek[index];

                                    const availableOfflineSchedule = coach?.availableOfflineSchedule?.value || [];
                                    const availableOnlineSchedule = coach?.availableOnlineSchedule?.value || [];
                                    const availableSchedule = availableTimeMenu === "online" ? availableOnlineSchedule : availableOfflineSchedule;

                                    return (
                                        <div key={index} style={{
                                            fontSize: "0.625rem",
                                            paddingTop: "0.57rem",
                                            paddingLeft: "0.64rem",
                                            paddingRight: "0.64rem",
                                            paddingBottom: "0.57rem",
                                            boxShadow: "2px 3px 22.9px -9.5px rgba(0, 0, 0, 0.25)",
                                            aspectRatio: "1/0.8",
                                            overflow: "hidden",
                                        }}>
                                            <span
                                                style={{
                                                    fontSize: "0.625rem"
                                                }}
                                            >{dayOfWeekText}요일</span>
                                            {
                                                availableSchedule.map((schedule: any, index2: number) => {

                                                    const timeString = schedule[dayOfWeekText];

                                                    return (
                                                        <div key={index2} style={{
                                                            marginTop: "0.3rem",
                                                            fontSize: "0.7rem",
                                                            fontFamily: "Apple_SB"
                                                        }}>
                                                            {timeString}
                                                        </div>
                                                    )

                                                })
                                            }
                                        </div>
                                    )
                                })
                            }
                        </div>
                        <div style={{
                            width: "90.4%",
                            margin: "0 auto",
                            marginTop: "4rem",
                            marginBottom: "1.06rem",
                        }}>
                            <div style={{
                                fontFamily: "Apple_B",
                                marginBottom: "1.12rem"
                            }}>
                                기본정보
                            </div>
                            <div>
                                {
                                    ["MBTI", "학교", "학과", "합격 입시전형", "과목별 수강강사"].map((item: any, index: number) => {

                                        const mbti = coach?.mbti?.value || "";
                                        const schoolName = coach?.schoolName?.value || "";
                                        const departmentName = coach?.departmentName?.value || "";
                                        var admissionType = "";

                                        if (coach?.admissionType?.value) {

                                            coach.admissionType.value.forEach((type: any) => {
                                                if (admissionType) {
                                                    admissionType += ", ";
                                                }
                                                admissionType += type;
                                            })

                                        }

                                        var value = "";

                                        switch (item) {
                                            case "MBTI":
                                                value = mbti;
                                                break;
                                            case "학교":
                                                value = schoolName;
                                                break;
                                            case "학과":
                                                value = departmentName;
                                                break;
                                            case "합격 입시전형":
                                                value = admissionType;
                                                break;
                                            default:
                                                value = "";
                                                break;
                                        }


                                        return (
                                            <div key={index} style={{
                                                color: "#888f9b",
                                                fontSize: "0.89rem",
                                                lineHeight: "1.34rem",
                                                marginBottom: "0.2rem",
                                                display: "flex",
                                                alignItems: "center",
                                            }}>
                                                <div style={{
                                                    width: "8.5rem",

                                                }}>
                                                    {item}
                                                </div>
                                                <div style={{
                                                    color: "#2a2a2a"
                                                }}>
                                                    {value}
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                            <div style={{
                                marginTop: "0.5rem",
                                display: "grid",
                                gridTemplateColumns: "repeat(4, 1fr)",
                                gap: "0.1rem",
                                width : "100%",
                                overflowX: "auto",
                            }}>
                                {
                                    ["국어", "수학", "영어", "탐구"].map((item: any, index: number) => {

                                        const coachingSubjects = coach?.subjectTeachers?.value || [];



                                        return (
                                            <div key={index} style={{
                                                aspectRatio: "1/1",
                                                paddingTop: "0.59rem",
                                                paddingLeft: "0.56rem",
                                                paddingRight: "0.56rem",
                                                backgroundColor: "#efefef",
                                                overflow : "auto"
                                            }}>
                                                <div style={{
                                                    fontSize: "0.812rem",
                                                    lineHeight: "1.3418rem"
                                                }}>
                                                    {item}
                                                </div>
                                                {
                                                    coachingSubjects.map((subjects: any, index2: number) => {

                                                        const teacherName = subjects[item];

                                                        if (!teacherName) {
                                                            return null;
                                                        }

                                                        return (
                                                            <div key={index2} style={{
                                                                fontSize: "0.75rem",
                                                                lineHeight: "1.34rem",
                                                                color: "#676767"
                                                            }}>
                                                                {teacherName}
                                                            </div>
                                                        )

                                                    })
                                                }
                                            </div>
                                        )

                                    })
                                }
                            </div>
                        </div>
                        <div style={{
                            width: "90.4%",
                            margin: "0 auto",
                            marginTop: "4rem",
                            marginBottom: "1.06rem",
                        }}>
                            <div style={{
                                fontFamily: "Apple_B",
                                marginBottom: "1.12rem"
                            }}>
                                코칭 정보
                            </div>
                            <div>
                                {
                                    ["코칭 가능 입시전형", "최소 코칭 보장기간"].map((item: any, index: number) => {

                                        const admissionType = coach?.admissionType?.value || [];

                                        var admissionTypeText = "";

                                        if (admissionType.length > 0) {
                                            admissionTypeText = admissionType.join(", ");
                                        }

                                        const minCoachingPeriod = coach?.minCoachingPeriod?.value?.end || "";

                                        var minCoachingPeriodText = "";

                                        if (minCoachingPeriod) {
                                            const endDate = new Date(minCoachingPeriod);
                                            minCoachingPeriodText = `${endDate.getFullYear()}.${endDate.getMonth() + 1}.${endDate.getDate()}`;
                                        }

                                        return (
                                            <div key={index}>
                                                <div style={{
                                                    color: "#888f9b",
                                                    fontSize: "0.89rem",
                                                    lineHeight: "1.34rem",
                                                    marginBottom: "0.2rem",
                                                    display: "flex",
                                                    alignItems: "center",
                                                }}>
                                                    <div style={{
                                                        width: "8.5rem",

                                                    }}>
                                                        {item}
                                                    </div>
                                                    <div style={{
                                                        color: "#2a2a2a"
                                                    }}>
                                                        {
                                                            item === "코칭 가능 입시전형" ? admissionTypeText
                                                                :
                                                                item === "최소 코칭 보장기간" ? minCoachingPeriodText
                                                                    :
                                                                    ""
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        )

                                    })
                                }
                            </div>
                            <div style={{
                                width: "100%",
                                margin: "0 auto",
                                marginTop: "0.6rem",
                                backgroundColor: "#f8f8f8",
                                padding: "1.18rem 0.875rem 1.187rem 0.875rem"
                            }}>
                                <div style={{
                                    fontFamily: "Apple_B",
                                    lineHeight: "1.5625rem",
                                    marginBottom: "0.3rem",
                                    color: "#888F9B"
                                }}>
                                    수업 스타일
                                </div>
                                <div style={{
                                    lineHeight: "1.5625rem",
                                    color: "#616161",
                                    fontSize: "0.9rem"
                                }}>
                                    {coach?.classStyle?.value}
                                </div>
                            </div>
                            <div style={{
                                width: "100%",
                                margin: "0 auto",
                                marginTop: "0.6rem",
                                backgroundColor: "#f8f8f8",
                                padding: "1.18rem 0.875rem 1.187rem 0.875rem"
                            }}>
                                <div style={{
                                    fontFamily: "Apple_B",
                                    lineHeight: "1.5625rem",
                                    marginBottom: "0.3rem",
                                    color: "#888F9B"
                                }}>
                                    이런 학생과 잘 맞아요!
                                </div>
                                <div style={{
                                    lineHeight: "1.5625rem",
                                    color: "#616161",
                                    fontSize: "0.9rem"
                                }}>
                                    {coach?.goodStudentFit?.value}
                                </div>
                            </div>
                        </div>
                        <div style={{
                            width: "90.4%",
                            margin: "0 auto",
                            marginTop: "4rem",
                            marginBottom: "1.06rem",
                        }}>
                            <div style={{
                                fontFamily: "Apple_B",
                                marginBottom: "1.12rem"
                            }}>
                                코칭 과목정보
                            </div>
                            <div style={{
                                fontSize: "0.89rem",
                                lineHeight: "1.34rem",
                                color: "#888f9b",
                                marginBottom: "0.6rem",
                            }}>
                                코칭 가능 과목
                            </div>
                            <div style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(3, 1fr)",
                                gap: "0.4rem",
                                marginBottom: "1.6rem"
                            }}>
                                {
                                    ["국어", "수학", "사탐", "과탐"].map((item: any, index: number) => {
                                        const coachingSubjects = coach?.coachingSubjects.value || [];

                                        return coachingSubjects.map((subjects: any, index2: number) => {
                                            const subjectName = subjects[item];

                                            if (!subjectName) {
                                                return null;
                                            }

                                            return (
                                                <div key={`${index}${index2}`} style={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    boxShadow: "2px 3px 22.9px -9.5px rgba(0, 0, 0, 0.25)",
                                                    backgroundColor: "white",
                                                    paddingTop: "0.43rem",
                                                    paddingBottom: "0.43rem",
                                                    fontSize: "0.89rem",
                                                    color: "#404956",
                                                    borderRadius: "1.43rem"
                                                }}>
                                                    {subjectName}
                                                </div>
                                            )
                                        })
                                    })
                                }
                            </div>
                            <div style={{
                                fontSize: "0.89rem",
                                lineHeight: "1.34rem",
                                color: "#888f9b",
                                marginBottom: "0.6rem",
                            }}>
                                질의응답 가능 과목
                            </div>
                            <div style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(3, 1fr)",
                                gap: "0.4rem",
                                marginBottom: "1.6rem"
                            }}>
                                {
                                    ["국어", "수학", "사탐", "과탐"].map((item: any, index: number) => {
                                        const qaSubjects = coach?.qaSubjects.value || [];

                                        return qaSubjects.map((subjects: any, index2: number) => {
                                            const subjectName = subjects[item];

                                            if (!subjectName) {
                                                return null;
                                            }

                                            return (
                                                <div key={`${index}${index2}`} style={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    boxShadow: "2px 3px 22.9px -9.5px rgba(0, 0, 0, 0.25)",
                                                    backgroundColor: "white",
                                                    paddingTop: "0.43rem",
                                                    paddingBottom: "0.43rem",
                                                    fontSize: "0.89rem",
                                                    color: "#404956",
                                                    borderRadius: "1.43rem"
                                                }}>
                                                    {subjectName}
                                                </div>
                                            )
                                        })
                                    })
                                }
                            </div>
                        </div>
                        <div style={{
                            width: "90.4%",
                            margin: "0 auto",
                            marginTop: "4rem",
                            marginBottom: "1.06rem",
                        }}>
                            <div style={{
                                fontFamily: "Apple_B",
                                marginBottom: "1.12rem"
                            }}>
                                자유 소개
                            </div>
                            <div style={{
                                whiteSpace: "pre-wrap",
                                fontSize: "0.9rem",
                                color: "#2a2a2a",
                                lineHeight: "1.34rem"
                            }}>
                                {
                                    coach?.freeIntroduction.value
                                }
                            </div>
                        </div>

                        <div style={{
                            width: "90.4%",
                            backgroundColor: "#3d50b0",
                            color: "white",
                            position: "fixed",
                            height: "3rem",
                            bottom: "1.5rem",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            borderRadius: "0.5rem",
                            left: "50%",
                            transform: "translateX(-50%)",
                            fontFamily: "Apple_SB",
                            opacity: disabled ? 0.35 : 1
                        }}
                            onClick={() => submit()}
                        >
                            코치매칭 신청하기
                        </div>
                    </div>
                    :
                    ""
            }


            <IonLoading
                cssClass='my-custom-class'
                isOpen={loading}
                onDidDismiss={() => setLoading(false)}
                message={'잠시만 기다려주세요'}
            />
        </div>
    )
}

export default MobileCoachDetail;  